import { Sprite, Container } from 'pixi.js'

export default {
  render: h => h(),
  beforeDestroy() {
    this.$tl.kill()
    this.chapter.$tl.remove()
    this.$stage.removeChild(this.$container)
    this.$container.destroy()

    // document.removeEventListener('keypress', this.onKeyPress)

  },
  data: () => ({
    chapter: null
  }),
  created() {

    this.$tl = new TimelineMax({ id: 'Chapter' })
    this.$container = new Container()
    this.chapter = _.find(this.chapters, chapter => chapter[this.lang].slug == this.$route.params.chapter )
    this.$resources = this.chapter.$loader.resources
    this.$stage = this.chapter.$pixi.stage
    this.$stage.addChild(this.$container)
    this.chapter.$tl.add(this.$tl, 0)

    // this.$container.scale.set(.5)

  },
  mounted() {
    this.$tl.time(this.chapter.$tl.time())
    // document.addEventListener('keypress', this.onKeyPress)
  },
  methods:{
    // onKeyPress(event) {
    //   // console.log(event.keyCode);
    //   const tl = this.chapter.$tl
    //   switch(event.keyCode) {
    //     case 32:
    //       if(tl.isActive()) tl.pause()
    //       else tl.play()
    //       break
    //     case 39:
    //     case 43:
    //     case 61:
    //     case 112:
    //     case 119:
    //       if(tl.isActive()) tl.pause()
    //       if(tl.time() < tl.duration()-1)tl.seek(tl.time()+1);
    //       break
    //     case 37:
    //     case 45:
    //     case 111:
    //     case 113:
    //       if(tl.isActive()) tl.pause()
    //       if(tl.time()>1) tl.seek(tl.time()-1);
    //       break
    //     case 49:
    //       if(tl.isActive()) tl.pause()
    //       if(tl.time() < tl.duration()-1)tl.seek(tl.time()+.1);
    //       break
    //   }
    // },
  }
}
